define(
  'ProductDetailsPage.EntryPoint',
  [],
  function () {
    'use strict';

    return {
      mountToApp: function mountToApp(container) {
        var layout = container.getComponent('Layout');
        var environment = container.getComponent('Environment');
        var themeHelpers = environment.getConfig('themeHelpers');
        var pdpConfiguration = themeHelpers && themeHelpers.pdp;

        if (layout && environment) {
          if (pdpConfiguration && pdpConfiguration.productDetailsInformationComponent) {
            layout.addToViewContextDefinition('ProductDetails.Information.View', 'productDetailsInformationComponent', 'string', function () {
              return pdpConfiguration.productDetailsInformationComponent;
            });
          }
        }
      }
    };
  });
